import lang from "../json/lang.json";
export const langSwitch = (domain,id, langtype)=>{
    return lang[domain][id][langtype];
}
